/* Shopping controls are event-driven; no timers, polling or background product requests. */
(function () {
  'use strict';
  var route = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var added = document.getElementById('uvAddedDialog');
  var saved = document.getElementById('uvSavedDialog');
  var activeRequest = false;
  function money(value, currency) {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'TRY' }).format(value / 100);
  }
  function open(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('uv-shop-open');
    return true;
  }
  [added, saved].forEach(function (dialog) {
    if (!dialog) return;
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('uv-shop-open'); });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-uv-close]')) dialog.close();
    });
  });
  function syncCart(cart) {
    document.querySelectorAll('[data-mk-cart-count], #cart-count').forEach(function (badge) {
      badge.textContent = cart.item_count;
      if (badge.hasAttribute('data-mk-cart-count')) badge.hidden = !cart.item_count;
    });
    var total = document.getElementById('cart-total');
    if (total) total.textContent = money(cart.total_price, cart.currency);
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') window.ajaxCart.load(false, false, false, true);
  }
  function confirm(item, quantity) {
    if (!added) { location.assign(route + 'cart'); return; }
    added.querySelector('[data-uv-added-title]').textContent = item.product_title || item.title;
    added.querySelector('[data-uv-added-option]').textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    added.querySelector('[data-uv-added-quantity]').textContent = quantity + ' adet eklendi';
    var image = added.querySelector('[data-uv-added-image]');
    var src = item.featured_image && item.featured_image.url || item.image;
    image.hidden = true;
    if (src) {
      try {
        var url = new URL(src, location.origin);
        if (url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com')) {
          url.searchParams.set('width', '160'); image.src = url.href; image.hidden = false;
        }
      } catch (ignore) {}
    }
    var total = added.querySelector('[data-uv-added-total]');
    total.textContent = 'Sepet güncelleniyor…';
    if (!open(added)) { location.assign(added.dataset.cartUrl); return; }
    fetch(route + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { if (!response.ok) throw Error(); return response.json(); })
      .then(function (cart) { total.textContent = cart.item_count + ' ürün · Sepet toplamı ' + money(cart.total_price, cart.currency); syncCart(cart); })
      .catch(function () { total.textContent = 'Ürün eklendi. Güncel toplamı sepetinizde görebilirsiniz.'; });
  }
  window.MedkaltecShopping = { confirm: confirm };
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-uv-quick-add]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (activeRequest || !form.reportValidity()) return;
    activeRequest = true;
    var button = form.querySelector('button'), label = button.textContent;
    var message = form.querySelector('[role="alert"]');
    var data = new FormData(form), quantity = Number(data.get('quantity')) || 1;
    document.querySelectorAll('[data-uv-quick-add] button').forEach(function (b) { b.disabled = true; });
    button.textContent = 'Ekleniyor…'; message.textContent = ''; form.setAttribute('aria-busy', 'true');
    fetch(route + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
      .then(function (response) { return response.json().then(function (item) { if (!response.ok) throw Error(item.description || 'Ürün eklenemedi. Stok bilgisini ürün sayfasından kontrol edin.'); return item; }); })
      .then(function (item) { confirm(item, quantity); })
      .catch(function (error) { message.textContent = error instanceof TypeError ? 'Bağlantı kesildi. Tekrar denemeden önce sepetinizi kontrol edin.' : error.message; })
      .finally(function () { activeRequest = false; button.textContent = label; form.removeAttribute('aria-busy'); document.querySelectorAll('[data-uv-quick-add] button').forEach(function (b) { b.disabled = false; }); });
  }, true);
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-uv-open-saved]');
    if (!trigger || !saved) return;
    event.preventDefault();
    var list = saved.querySelector('[data-uv-saved-list]'), rows = [];
    try { var parsed = JSON.parse(localStorage.getItem('medkaltec:saved:v1') || '[]'); if (Array.isArray(parsed)) rows = parsed.slice(0, 12); } catch (ignore) {}
    list.replaceChildren();
    rows.forEach(function (product) {
      if (!product || typeof product.url !== 'string' || typeof product.title !== 'string') return;
      try {
        var url = new URL(product.url, location.origin);
        if (url.origin !== location.origin || !/^\/products\/[^/]+$/.test(url.pathname) || url.search || url.hash) return;
        var link = document.createElement('a'); link.className = 'uv-saved-link'; link.href = url.pathname;
        var title = document.createElement('span'); title.textContent = product.title;
        var arrow = document.createElement('span'); arrow.textContent = '→'; arrow.setAttribute('aria-hidden', 'true');
        link.append(title, arrow); list.appendChild(link);
      } catch (ignore) {}
    });
    saved.querySelector('[data-uv-saved-empty]').hidden = !!list.children.length;
    if (!open(saved)) location.assign(route + 'collections/all');
  });
})();
